export async function delay(ms: number) {
  await new Promise((resolve) => {
    setTimeout(() => {
      resolve(true)
    }, ms)
  })
}

export async function retryWithExponentialBackoff<T>(
  fn: () => Promise<T>,
  shouldRetry: (result: T) => boolean,
  initialDelay: number = 2000,
  maxAttempts: number = 10,
): Promise<T> {
  let attempt = 0
  let currentDelay = initialDelay

  while (true) {
    const result = await fn()

    if (!shouldRetry(result) || attempt >= maxAttempts) {
      return result
    }

    attempt++
    await delay(currentDelay)
    currentDelay *= 2
  }
}
